import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class MediaService {

  private url = `${environment.api}/media`;

  constructor(private http: HttpClient) {
  }

  /**
   * Get file by uri
   * @param {string} uri
   * @returns {Observable<Response>}
   */
  get(uri: string) {
    const params: HttpParams = new HttpParams()
      .append('search', uri);

    return this.http.get(this.url, {
      params: params,
    });
  }

  /**
   * Upload file
   * @param {File} file
   * @param {string} type
   * @returns {Observable<Response>}
   */
  upload(file: File, type: string) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.url}/type`, formData);
  }

  copy(type: string, uri: string): Observable<string> {

    const url = `${this.url}/${type}/copy`;

    const params: HttpParams = new HttpParams()
      .append('uri', uri);

    return this.http.post<string>(url, {}, { params: params });
  }
}
